import { Badge } from '@design/components/badge/Badge';
import { Button } from '@design/components/button/Button';
import { DropdownMenu } from '@design/components/dropdown-menu/DropdownMenu';
import { Icon } from '@design/components/icon/Icon';
import { NewsFilter } from '@terminal/services/news/news.types';
import { SideAccordionFilters } from '@terminal/views/news/components/side-accordion-filters/SideAccordionFilters';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './MoreFilters.module.scss';

export interface MoreFiltersProps {
  moreFiltersSelectedCount: number;
  filters: NewsFilter[];
  toggleFilterOption: (
    filterKey: string,
    optionKey?: string,
    trackFilter?: () => void
  ) => void;
}

export const MoreFilters = ({
  moreFiltersSelectedCount,
  filters,
  toggleFilterOption,
}: MoreFiltersProps) => {
  const { t } = useTranslation('news');

  const [isMoreFilterOpen, setIsMoreFilterOpen] = useState(false);

  return (
    <DropdownMenu
      open={isMoreFilterOpen}
      onOpenChange={() => setIsMoreFilterOpen(prev => !prev)}
      triggerNode={
        <Button
          className={styles.moreFilterPill}
          variant="tertiary"
          size="small"
          label={t('news:filters.moreFilters')}
        >
          <div className={styles.bottomSection}>
            {!!moreFiltersSelectedCount && (
              <Badge
                className={styles.badge}
                variant="numerical"
                label={moreFiltersSelectedCount}
                size="small"
                data-testid={`count-badge-${moreFiltersSelectedCount}`}
              />
            )}
            <Icon
              size={14}
              iconName="ChevronLightDown"
              fillColor="var(--text-soft)"
            />
          </div>
        </Button>
      }
      contentProps={{
        asChild: true,
      }}
    >
      <div className={styles.menuWrapper}>
        <SideAccordionFilters
          filters={filters}
          toggleFilterOption={toggleFilterOption}
        />
      </div>
    </DropdownMenu>
  );
};
